import React, { useEffect, useRef } from "react";

// Luxurious matrix code rain: slow turquoise/green fall, occasional pink data pulses, soft fog.
export const MatrixRain = ({ opacity = 0.22 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    const chars = "アイウエオカキ0123456789ABCDEFΣΦΨΩ<>/#*+".split("");
    let cols, drops, speeds, colors, fontSize = 15;

    const palette = () => {
      const r = Math.random();
      if (r > 0.9) return "#ff007f";      // rare pink data pulse
      if (r > 0.55) return "#39ff14";     // electric green
      return "#00f0ff";                    // turquoise
    };

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      cols = Math.floor(canvas.width / fontSize);
      drops = Array(cols).fill(0).map(() => Math.random() * -canvas.height / fontSize);
      speeds = Array(cols).fill(0).map(() => 0.35 + Math.random() * 0.4); // slow
      colors = Array(cols).fill(0).map(palette);
    };
    resize();
    window.addEventListener("resize", resize);

    let last = 0;
    const draw = (t) => {
      if (t - last > 60) {
        last = t;
        ctx.fillStyle = "rgba(5,5,5,0.10)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.font = `${fontSize}px 'JetBrains Mono', monospace`;
        for (let i = 0; i < cols; i++) {
          const text = chars[Math.floor(Math.random() * chars.length)];
          const y = drops[i] * fontSize;
          ctx.shadowBlur = 8;
          ctx.shadowColor = colors[i];
          ctx.fillStyle = colors[i];
          ctx.fillText(text, i * fontSize, y);
          ctx.shadowBlur = 0;
          if (y > canvas.height && Math.random() > 0.985) {
            drops[i] = 0;
            colors[i] = palette();
          }
          drops[i] += speeds[i];
        }
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden" style={{ opacity }}>
      <canvas ref={ref} className="absolute inset-0 w-full h-full" />
      {/* soft luxurious fog */}
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse at 50% 40%, rgba(0,240,255,0.05), transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(255,0,127,0.04), transparent 55%)" }} />
      <div className="absolute inset-x-0 top-0 h-32 pointer-events-none" style={{ background: "linear-gradient(180deg, rgba(5,5,5,0.9), transparent)" }} />
      <div className="absolute inset-x-0 bottom-0 h-40 pointer-events-none" style={{ background: "linear-gradient(0deg, rgba(5,5,5,0.95), transparent)" }} />
    </div>
  );
};
